import React, { Component } from 'react';
import { Link, NavLink } from 'react-router-dom';
import { connect } from 'react-redux';

import logo from './../../assets/images/brand/assista_horizontal-punchout.svg';

class Navbar extends Component {
    render() {
        return (
            <header className="border-light border-bottom bg-white text-center navbar navbar-light navbar-expand-md mb-3 mb-lg-4 px-0">
                <div className="container-fluid container-hd px-sm">
                    <Link className="h3 navbar-brand my-auto" to={"/index"}>
                        <img className="img-fluid" src={logo} alt="Assist@" width="140" />
                        <h1 className="sr-only visually-hidden">Assist@: Menu</h1>
                    </Link>
                    <button className="navbar-toggler border-0" type="button" data-toggle="collapse" data-target="#navbar-collapse" aria-controls="navbar-collapse" aria-expanded="false" aria-label="Toggle navigation">
                        <span className="navbar-toggler-icon"></span>
                    </button>
                    <nav className={"collapse navbar-collapse"} id="navbar-collapse">
                        <h1 className="sr-only visually-hidden">Menu: navigation</h1>
                        <ul className="nav navbar-nav ml-auto">
                            <li className="nav-item">
                                <NavLink className="nav-link px-3" activeClassName="text-primary" to="/legal/terms">Mentions Légales</NavLink>
                            </li>
                            <li className="nav-item">
                                <NavLink className="nav-link px-3" activeClassName="text-primary" to="/legal/privacy" disabled>Confidentialité</NavLink>
                            </li>
                        </ul>
                    </nav>
                </div>
            </header>
        )
    }
}

const mapStateToProps = (state) => ({
    example: state.example,
  });
const mapDispatchToProps = {

};

export default connect(mapStateToProps, mapDispatchToProps)(Navbar);